export enum ReminderEntityType {
  CLAIM = 'CLAIM',
  POLICY = 'POLICY',
  LEAD = 'LEAD',
  PARTNER = 'PARTNER',
}

export interface ReminderContext {
  entityType?: ReminderEntityType;
  code?: string;
}

export interface ReminderCountsResponse {
  data: {
    dueCount?: number;
    overdueCount?: number;
  };
}

export interface RemindersApiClient {
  getReminderCounts(
    params: { authorization: string; filters: string },
  ): Promise<ReminderCountsResponse>;
}

export interface TaskSdkModule {
  Configuration: new () => unknown;
  RemindersApi: new ( configuration?: unknown, basePath?: string ) => RemindersApiClient;
}
